var _style, _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .rectPreviewPlaceHolder{\n      fill: rgb(51, 51, 51);\n      outline: rgb(51, 51, 51) solid 1px;\n      outline-offset: -1px;\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    className: "rectPreviewPlaceHolder"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    fontSize: 14,
    fontFamily: "monospace, sans-serif",
    fill: "#fff",
    textAnchor: "middle",
    alignmentBaseline: "middle"
  }, "16:9\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewPlaceholder);
export default __webpack_public_path__ + "static/media/previewPlaceholder.0d5bd1c8f0441f31ab2c7007e4da55d3.svg";
export { ForwardRef as ReactComponent };